// Anzeige-Reihenfolge der Sektoren: nach der vergebenen Sektornummer bzw. dem
// Code, nicht nach `sortOrder`.
//
// `sortOrder` bleibt, was es ist — der Tiebreaker, wenn sich zwei Sektoren
// überlappen und dieselbe Priorität haben (siehe Sektorverwaltung). Für die
// Anzeige ist die Nummer das, wonach ein Mensch sucht.
//
// `localeCompare` mit `numeric: true` sortiert „S2" vor „S10"; ein reiner
// String-Vergleich würde bei zweistelligen Nummern falsch liegen. Dieselbe
// Reihenfolge stellt in der Fahrer-App `Sector.compareByCode` her.

const CODE_COLLATION = { numeric: true, sensitivity: 'base' };

export const compareSectorsByCode = (a, b) => {
  const codeA = (a?.code || '').trim();
  const codeB = (b?.code || '').trim();
  // Sektoren ohne Nummer ans Ende, sonst stünden sie durch den leeren String
  // ganz oben.
  if (!codeA !== !codeB) return codeA ? -1 : 1;
  const byCode = codeA.localeCompare(codeB, 'de', CODE_COLLATION);
  if (byCode !== 0) return byCode;
  return (a?.name || '').localeCompare(b?.name || '', 'de', CODE_COLLATION);
};

/// Kopiert die Liste, bevor sie sortiert wird — Redux-State ist eingefroren.
export const sortSectorsByCode = (sectors) =>
  [...(sectors || [])].sort(compareSectorsByCode);
